module.exports = __webpack_public_path__ + "img/antes_despues_124.522849e4.png";